module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-ind-ce3b1a6c0615178b786660a44b27e82b.png";